import { render, staticRenderFns } from "./CardsStatusSelect.vue?vue&type=template&id=496fc1f2&scoped=true"
import script from "./CardsStatusSelect.vue?vue&type=script&lang=js"
export * from "./CardsStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496fc1f2",
  null
  
)

export default component.exports